import React from 'react';
import TalkToExpert from '../components/TalkToExpert';
import './ServicePage.css';

const Certificates = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Certifications & Accreditations</h1>
            <p className="service-description">
              Our team holds industry-leading certifications ensuring 
              the highest standards of service and expertise.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Industry Certifications</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🏅</div>
                    <h3>CompTIA Certifications</h3>
                  </div>
                  <p>A+, Network+, Security+, and other CompTIA certifications across our technical team.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🌐</div>
                    <h3>Cisco Certified</h3>
                  </div>
                  <p>CCNA, CCNP, and CCIE certified engineers for network infrastructure and security.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">☁️</div>
                    <h3>Cloud Certifications</h3>
                  </div>
                  <p>AWS, Microsoft Azure, and Google Cloud certified professionals for cloud solutions.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔒</div>
                    <h3>Security Certifications</h3>
                  </div>
                  <p>CISSP, CEH, and other cybersecurity certifications for comprehensive security services.</p>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Quality Assurance</h2>
                <ul className="benefits-list">
                  <li>✓ ISO 27001 certified for information security</li>
                  <li>✓ ITIL framework for service management</li>
                  <li>✓ Regular certification renewals and updates</li>
                  <li>✓ Continuous professional development</li>
                  <li>✓ Industry best practices implementation</li>
                  <li>✓ Compliance with international standards</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Certification Stats</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Total Certs:</span>
                  <span className="highlight-value">10+</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Vendors:</span>
                  <span className="highlight-value">6+</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Renewal Rate:</span>
                  <span className="highlight-value">100%</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label"></span>
                  <span className=""> </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default Certificates;
